export default __webpack_public_path__ + "static/media/sup.3ff9ce0b.svg";